<template>
  <basic-dialog :show="show" @close="$emit('close')" max-width="800">
    <template v-slot:title>{{ editorTitle }}</template>
    <v-row>
      <v-col cols="12" sm="8">
        <v-text-field
          v-model="name"
          label="Name"
          :outlined="outlinedInputs"
          hide-details
        ></v-text-field>
      </v-col>
      <v-col cols="12" sm="4">
        <v-text-field
          v-model="code"
          label="Code"
          :outlined="outlinedInputs"
          hide-details
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-textarea
          v-model="description"
          label="Description"
          :outlined="outlinedInputs"
          hide-details
        ></v-textarea>
      </v-col>
    </v-row>
    <v-row>
      <v-col sm="4">
        <v-checkbox
          hide-details
          v-model="commission"
          label="Receivable Commission %"
        ></v-checkbox>
      </v-col>
      <v-col sm="4">
        <v-checkbox
          hide-details
          v-model="markup"
          label="Use Markups"
        ></v-checkbox>
      </v-col>
      <v-col sm="4">
        <v-checkbox
          hide-details
          v-model="createPI"
          label="Create PI"
        ></v-checkbox>
      </v-col>
      <v-col sm="4">
        <v-checkbox
          hide-details
          v-model="setAsOptional"
          label="Set as Optional"
        ></v-checkbox>
      </v-col>
      <v-col>
        <v-checkbox
          hide-details
          v-model="includesFlagOn"
          label="Includes Flag On"
        ></v-checkbox>
      </v-col>
      <v-col>
        <v-checkbox
          hide-details
          v-model="editableFlags"
          label="Editable Flags"
        ></v-checkbox>
      </v-col>
    </v-row>
    <template v-slot:actions>
      <v-btn color="primary" @click="onSave" :disabled="!isValid">Save</v-btn>
    </template>
    <div v-if="debug">
      <code>{{ value }}</code>
    </div>
  </basic-dialog>
</template>

<script>
import BasicDialog from "../../shared/BasicDialog";
export default {
  name: "edit-business-model-dialog",

  props: {
    show: {
      type: Boolean,
      default: () => false,
    },
    value: {
      type: Object,
      default: () => null,
    },
  },

  components: { BasicDialog },

  data() {
    return {
      debug: false,
      name: this.value ? this.value.name : "",
      code: this.value ? this.value.code : "",
      description: this.value ? this.value.description : "",
      commission: this.value ? this.value.commission : false,
      markup: this.value ? this.value.markup : false,
      zeroSellPrice: this.value ? this.value.zeroSellPrice : false,
      createPI: this.value ? this.value.createPI : false,
      setAsOptional: this.value ? this.value.setAsOptional : false,
      includesFlagOn: this.value ? this.value.includesFlagOn : false,
      editableFlags: this.value ? this.value.editableFlags : false,
    };
  },

  computed: {
    outlinedInputs() {
      return this.$store.getters.localSettings("outlinedInputs");
    },
    editorTitle() {
      return `${this.value && this.value.id ? "Edit" : "Add"} - ${this.name}`;
    },
    isValid() {
      return this.name && this.name != "" && this.code != "";
    },
  },

  watch: {
    value(newVal) {
      this.name = newVal.name;
      this.code = newVal.code;
      this.description = newVal.description;
      this.commission = newVal.commission;
      this.commission = newVal.commission;
      this.zeroSellPrice = newVal.zeroSellPrice;
      this.createPI = newVal.createPI;
      this.setAsOptional = newVal.setAsOptional;
      this.includesFlagOn = newVal.includesFlagOn;
      this.editableFlags = newVal.editableFlags;
    },
  },

  methods: {
    onSave() {
      this.$emit("input", {
        id: this.value && this.value.id ? this.value.id : undefined,
        name: this.name,
        code: this.code,
        description: this.description,
        commission: this.commission ? true : false,
        markup: this.markup ? true : false,
        zeroSellPrice: this.zeroSellPrice ? true : false,
        createPI: this.createPI ? true : false,
        setAsOptional: this.setAsOptional ? true : false,
        includesFlagOn: this.includesFlagOn ? true : false,
        editableFlags: this.editableFlags ? true : false,
      });
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/admin/department-types/EditBusinessModelDialog.vue